<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-10-24 17:18:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-24 11:25:40
-->
<template>
  <mrc_ess_chip rounded
                text-color="rgba(255, 255, 255, 0.95)"
                :color="Number(is_used) === true_value ? '#18A874' : 'grey'"
                :small="small">
    <template v-if="label">
      {{INT(label)}}
    </template>
    <template v-else>
      {{
      Number(is_used) === true_value
        ? true_view
          ? true_view
          : $t('label_To_enable_the')
        : false_view
        ? false_view
        : $t('label_disable')
    }}
    </template>
  </mrc_ess_chip>
</template>

<script>
import { get_dict_name } from '@/service/api/data_dictionary'
import { getBusinessList } from '@/service/api/prompt'
export default {
  components: {},
  props: {
    is_used: {},
    label: { //显示字段
    },
    small: {
      default: true,
    },
    true_value: {
      //正确显示的值
      default: 1,
    },
    true_view: {},
    false_view: {},
    dict_name: {}
  },
  data () {
    return {
      selectList: []
    }
  },
  async created () {
    // if (!this.dict_name) {
    //   const res = await get_dict_name({ dict_name: 'is_used' })
    //   if (res.code == 200) {
    //     if (Array.isArray(res.data) && res.data.length > 0) {
    //       this.selectList = res.data
    //     } else {
    //       this.selectList = []
    //     }
    //   }
    // }
    // else {
    //   let dictName = null
    //   if (typeof val == 'string') {
    //     dictName = { dict_name: val }
    //   }
    //   else {
    //     dictName = val
    //   }
    //   const res = await get_dict_name({ dict_name: dictName })
    //   if (res.code == 200) {
    //     if (Array.isArray(res.data) && res.data.length > 0) {
    //       this.selectList = res.data
    //     } else {
    //       this.selectList = []
    //     }
    //   }
    // }
  },
  mounted () { },
  methods: {
    // valueView () {
    //   let obj = {}
    //   this.selectList.filter(item => {
    //     if (item.dict_value == this.is_used) {
    //       obj = item
    //     }
    //   })
    //   return obj
    // }
  },
  computed: {},
  watch: {
    // dict_name: {
    //   async handler (val) {
    //     if (!val) {
    //       const res = await get_dict_name({ dict_name: 'is_used' })
    //       if (res.code == 200) {
    //         if (Array.isArray(res.data) && res.data.length > 0) {
    //           this.selectList = res.data
    //         } else {
    //           this.selectList = []
    //         }
    //       }
    //     }
    //     else {
    //       let dictName = null
    //       if (typeof val == 'string') {
    //         dictName = { dict_name: val }
    //       }
    //       else {
    //         dictName = val
    //       }
    //       const res = await get_dict_name({ dict_name: dictName })
    //       if (res.code == 200) {
    //         if (Array.isArray(res.data) && res.data.length > 0) {
    //           this.selectList = res.data
    //         } else {
    //           this.selectList = []
    //         }
    //       }
    //     }
    //   }
    // }
  },
}
</script>

<style scoped></style>
